<template>
   <div class="widget-multi-table-container">
      <Cards :status="properties?.extras" :rows="properties?.content" />

      <!-- Multiple Table Header  -->
      <Section class="multiple-table-header-wrapper" v-if="properties?.multitable?.status">
         <div class="multi-table-tabs">
            <template v-for="(tab, index) in properties.multitable?.tabs">
               <div class="multi-table-tab" :key="index" :class="{ 'multi-table-active-tab': index === mode, 'disabled-tab': progress }" @click="handlerSwitchTab(index, tab.widgetItem)">
                  {{ $t(tab.name) }}
               </div>
            </template>
         </div>
         <div class="show-flight-wksc-btn-wrapper" v-if="properties?.type == 2 && [200, 201].includes(activeTab) && $constants.brand.cssCode == 'mefly'">
            <button class="show-flight-wksc" :disabled="disableFltWksc" :class="onlyFltWksc ? 'filter-active' : ''" ref="wksc" @click="handlerOnlyFlightChanges">
               <i class="gts-icon icon-flight_change gts-animation"></i>
               {{ $t("dashboardTable_onlyFlightChanges") }}
               <strong v-if="onlyFltWksc"> ({{ onlyFltWkscCount }}) </strong>
               <strong v-else> <i class="gts-icon icon-notification-list icon-navbar icon-xs"></i> </strong>
            </button>
            <span class="show-flight-wksc-txt" v-if="!onlyFltWksc">({{ this.$store.state.app.reportUpcomingsDateInfo }})</span>
            <span class="show-flight-wksc-txt" v-else>({{ today + "-" + tenDaysLater }})</span>
         </div>
      </Section>
      <Table
         :properties="properties"
         :rows="properties?.content"
         :loading="progress"
         :resetPagination="resetPagination"
         @onlyOnlineCheckIns="handlerOnlyOnlineCheckIns"
         @expiredFlights="
            () => {
               this.expiredFlights = !this.expiredFlights;
               handlerSwitchTab(mode, properties.multitable.tabs[mode].widgetItem, true);
            }
         "
         @onlyFltWksc="
            () => {
               this.onlyFltWksc = !this.onlyFltWksc;
               handlerSwitchTab(mode, properties.multitable.tabs[mode].widgetItem, true);
            }
         "
         @resetPagination="resetPagination = !resetPagination"
         :activeTab="activeTab" />
   </div>
</template>

<script>
import WidgetControls from "@/components/widgets/helpers/widget-helpers.js";
import { dashboardService } from "@/service/index.js";
import Cards from "@/components/widgets/Extras/Cards.vue";
import Table from "@/components/widgets/Table.vue";
import moment from "moment";
export default {
   Name: "MultiTable",
   props: {
      properties: [Object, Array],
   },
   components: {
      Table,
      Cards,
   },
   data() {
      return {
         search: "",
         mode: 0,
         tabs: [],
         progress: false,
         expiredFlights: false,
         onlyFltWksc: false,
         onlyFltWkscCount: null,
         today: moment().format("DD.MM.YYYY"),
         sixMonthsLater: moment().add(6, "months").format("DD.MM.YYYY"),
         tenDaysLater: moment().add(10, "days").format("DD.MM.YYYY"),
         disableFltWksc: false,
         activeTab: this.properties?.multitable?.tabs[0].widgetItem,
         resetPagination: false,
      };
   },
   created() {},

   methods: {
      handlerOnlyOnlineCheckIns(status) {
         if (status) {
            this.disableFltWksc = true;
         } else {
            this.disableFltWksc = false;
         }
      },
      handlerOnlyFlightChanges() {
         this.onlyFltWksc = !this.onlyFltWksc;
         this.$store.commit("app/setOnlyFltWksc", this.onlyFltWksc);
         this.mode = 1;
         this.activeTab = 201;
         this.handlerSwitchTab(this.mode, this.activeTab, true);
      },
      handlerSwitchTab(index, widgetItem, bypass) {
         if (this.activeTab != widgetItem || bypass) {
            if (widgetItem != 101) {
               this.expiredFlights = false;
            }
            if (widgetItem != 201) {
               this.onlyFltWksc = false;
               this.$store.commit("app/setOnlyFltWksc", this.onlyFltWksc);
            }
            this.progress = true;
            this.mode = index;
            this.activeTab = widgetItem;
            const service = this.properties.multitable.service;
            const responseObj = this.properties.multitable.name;
            const params = {
               widgetItem: widgetItem,
            };
            if (widgetItem == 101) {
               params.expiredFlights = this.expiredFlights;
            }
            if (widgetItem == 201) {
               this.$store.commit("app/setOnlyFltWksc", this.onlyFltWksc);
               params.onlyFltWksc = this.onlyFltWksc;
            }
            dashboardService[service](params).then((response) => {
               if (params.onlyFltWksc) {
                  this.onlyFltWkscCount = response.upcomings.length;
               }
               this.resetPagination = true;
               this.progress = false;
               this.$parent.$emit("dynamicFeed", {
                  order: this.properties.order,
                  content: WidgetControls.DynamicFeed(response[responseObj]),
               });
            });
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.widget-multi-table-container {
   section.multiple-table-header-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 0.5rem 0;
      margin-bottom: 2rem;
      height: fit-content;

      .show-flight-wksc-btn-wrapper {
         .show-flight-wksc-txt {
            font-size: var(--small);
            color: var(--gray-500);
         }

         i.icon-notification-list {
            margin: 0;
            padding: 0;
            transform: scale(0.8);
            margin-left: 0.5rem;
         }
      }
      .show-online-checkins,
      .show-partial-paids,
      .show-online-reservations,
      .show-flight-wksc,
      .show-charter-flights {
         strong {
            font-weight: 600;
            padding-left: 0.125rem;
         }
         &.filter-active {
            background-color: var(--yellow-400);
            border-color: transparent !important;
            //color: var(--gray-50);
            color: var(--gray-0);
         }
         &:disabled {
            opacity: 0.5;
            cursor: default;
         }
         display: flex;
         align-items: center;

         border-radius: 0.5rem;
         padding: 0.5rem 1rem;
         padding-left: 0.5rem;
         background: var(--gray-200);

         color: var(--gray-700) !important;
         i {
            width: 24px !important;
            height: 24px !important;
            margin-right: 0.5rem;
         }
         .gts-tooltip {
            padding: 0px !important;
         }
      }

      .report-multi-table-info-container {
         display: flex;
         flex-direction: column;
         height: 20px;
         width: 190px;
         align-items: flex-end;
         span {
            display: flex;
            justify-content: center;
            font-weight: 600;
            font-size: var(--normal);
         }
         .gts-tooltip {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20%;
            padding: 0rem !important;
            z-index: 1;
            ::v-deep {
               i.gts-icon {
                  width: 32px !important;
                  height: 32px !important;
               }
            }
         }
      }
      .multi-table-tabs {
         display: flex;
         align-items: center;
         background: var(--multitable-bg);
         border-radius: 8px;
         height: 40px;
         @media (max-width: 576px) {
            width: 100%;
         }

         .multi-table-tab {
            padding: 0.25rem 0.75rem;
            margin-right: 0.5rem;
            font-weight: 400;
            color: var(--gray-600);
            height: 32px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &.multi-table-active-tab {
               //color: var(--gray-50);
               color: var(--gray-0);
               font-weight: 500;
               background-color: var(--gray-800);
               border-radius: 8px;

               small {
                  //background-color: var(--gray-50);
                  background-color: var(--gray-0);
               }
            }
            &.disabled-tab {
               pointer-events: none;
            }
         }
      }
      .multi-table-search {
         input {
            width: 140px;
            border-radius: 24rem;
            outline: 0;
            border: 2px solid var(--gts-input-border);
            height: 40px;
            text-indent: 1rem;
            color: var(--gray-800);
            text-transform: uppercase;
            font-size: var(--small);
            background-color: var(--gts-input-background);

            &:focus {
               border-color: var(--accent-primary-light);
               background-color: var(--blue-200-alpha-10);
               font-weight: 500;
            }

            &::-webkit-input-placeholder {
               text-transform: capitalize;
            }
         }
      }
   }
}
</style>

<style lang="scss">
.widget-multi-table-container {
   .tabs {
      display: none !important;
   }
}
</style>
